export const ADMIN_MENU = {
    DASHBOARD : {
        TYPE : 'MAIN',
        ID: 'DASHBOARD',
        URL : '/',
        TEXT : '대시보드'
    },
    CLIENT : {
        TYPE : 'MAIN',
        ID: 'CLIENT',
        URL : '/client',
        TEXT : '고객사관리'
    },
    PROJECT : {
        TYPE : 'MAIN',
        ID: 'PROJECT',
        URL : '/project',
        TEXT : '과업관리'
    },
    PROJECT_DETAIL : {
        P_MENU: 'PROJECT',
        TYPE : 'SUB',
        ID: 'PROJECT_DETAIL',
        URL : '/project',
        TEXT : 'asdasdasdas'
    },
    SCHEDULE : {
        TYPE : 'MAIN',
        ID: 'SCHEDULE',
        URL : '/schedule/setup',
        TEXT : '일정관리'
    },
    SCHEDULE_SETUP : {
        P_MENU: 'SCHEDULE',
        TYPE : 'SUB',
        ID: 'SCHEDULE_SETUP',
        URL : '/schedule/setup',
        TEXT : '설치일정'
    },
    SCHEDULE_CODING : {
        P_MENU: 'SCHEDULE',
        TYPE : 'SUB',
        ID: 'SCHEDULE_CODING',
        URL : '/schedule/coding',
        TEXT : '코딩일정'
    },
    CARS : {
        TYPE : 'MAIN',
        ID: 'CARS',
        URL : '/cars',
        TEXT : '차종관리'
    },
}

export const USER_TP = {
    SUPER : 'A',
    ADMIN : 'M',
    MANAGE : 'G',//일단 전체
    USER : 'U', //설치기사(자산관리/자산조사 없고 반출입작업생성불가)
    NORMAL: 'N' //대시보드하고 비밀번호변경
}

export const USER_MENU = {
    SUPER : {
        ADMIN : [
            ADMIN_MENU.DASHBOARD,
            ADMIN_MENU.CLIENT,
            ADMIN_MENU.PROJECT,
            // ADMIN_MENU.SCHEDULE,
            // ADMIN_MENU.SCHEDULE_SETUP,
            // ADMIN_MENU.SCHEDULE_CODING,
            ADMIN_MENU.CARS,
                ],
    },
}

export const DEPT_CD = {
    TP: 'T1',
    CP: 'C1',
    TS : 'S1',
    ICT : 'I1',
    MG : 'M1',
    ETC : 'Z1',
}